import {BrandPortal} from '../types';

// TODO: right now this is supporting the brand portal model and the new brand portal settings context
// the items using this right now are in js and will not care but eventually need to get the two as the same
// Maybe keeping goo was a mistake on my part... but spreading it on the top of the model also doesn't strike
// me as the "correct" move but ¯\_(ツ)_/¯
// So throughout this we will first check the top level and then check the goo

/**
 * Has updated portal attribute system\
 * Has a user updated the portal settings since the attributes upgrade?
 * @param portal Brand portal
 * @return Has updated attribute system
 */
export const hasUpdatedAttributesSystem = (portal: BrandPortal) => {
	return (
		(portal as any).upgradedFeatures?.includes('attributes') ||
		portal.goo.upgradedFeatures?.includes('attributes')
	);
};
export default hasUpdatedAttributesSystem;
